import { Modal, OfficeButton } from 'components';
import { FormikProps } from 'formik';
import { FC } from 'react';
import UploadFile from './cards/upload';

type Props = {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
  form: FormikProps<any>;
  loading: boolean;
};

const UploadProductContainer: FC<Props> = ({
  form,
  open,
  setOpen,
  loading,
}) => {
  return (
    <Modal
      title='Upload Products'
      description='Upload products by selecting the sku column in an excel file'
      setOpen={setOpen}
      open={open}
      loading={loading}
      renderActions={() => (
        <div className='ml-2'>
          <OfficeButton
            type='button'
            onClick={() => {
              form.setFieldValue(
                'products',
                form.values.products_sku?.map((data: any) =>
                  data[form?.values?.sku_column || '']?.toString()
                )
              );
              setOpen(false);
            }}>
            Done
          </OfficeButton>
        </div>
      )}>
      <UploadFile form={form} />
    </Modal>
  );
};

export default UploadProductContainer;
